import EditableInput from './EditableInput';
import withEditableArea from './withEditableArea';

const withEditableInput = (DisplayComponent, WrapperComponent) => {
  return withEditableArea(DisplayComponent, EditableInput, WrapperComponent);
};

export default withEditableInput;
